<div class="popup" *ngIf="$isVisiblePopupMap">
  <div class="row title-row">
    <div class="col-13 button-col">
      <button mat-raised-button class="popup_buttons" routerLinkActive="router-link-active" (click)="CancelButton()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="col-12">
      <label class="popup_title">Detalle de Ubicación</label>
    </div>
    <div class="col-12">
      <label class="popup_subtitle">Ult. Conexión <br> {{ this.LastUpdate | date: "dd/MM/yyyy HH:mm:ss a" }}</label>
    </div>
    
    <!-- <div class="col">
      <label class="popup_subtitle">{{ this.Address }}</label>
    </div> -->
  </div>

  <div class="row container bloque">
    <ng-container *ngFor="let key of Keys; let i = index">
      <div class="col-12 key-block" *ngIf="!key.startsWith('_') && getNameVisibility(key)">
        <div class="row-3">
          <p class="popup_key">{{ getUsableName(key) }}</p>
        </div>
        <div class="row-6">
          <img class="item-icon" [src]="'/assets/img/' + getImageFileName(key)" (error)="onImageError($event)">
        </div>
        <div class="row-3">
          <p class="popup_value">{{ this.Values[i] }}</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
